// app/(app)/inventory/stock/_layout.tsx
import { useAppTheme } from "@/hooks/useAppTheme";
import { Stack } from "expo-router";

export default function StockLayout() {
  const { colors } = useAppTheme();

  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: colors.background },
        headerTintColor: colors.text,
        headerShadowVisible: false,
        contentStyle: { backgroundColor: colors.background },
      }}
    >
      <Stack.Screen
        name="index"
        options={{ title: "Stock Records", headerShown: false }}
      />
      <Stack.Screen
        name="add"
        options={{ title: "Add Stock Entry", presentation: "modal" }}
      />
      <Stack.Screen name="[id]" options={{ title: "Edit Stock Entry" }} />
    </Stack>
  );
}
